import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import CreateAffiliateInvoiceComponent from "../../../../component/Affiliate/AffiliateInvoice/CreateAffiliateInvoice";
import {
  getAffiliateInvoiceDetail,
  generateAffiliateInvoice,
  updateAffiliateInvoice,
  fetchAffiliateInvoicePayments,
  recordAffiliatePayment,
  updateAffiliatePayment,
} from "../../../../redux/actions/Affiliate/affiliateInvoice";
import { fetchAffiliateDD } from "../../../../redux/actions/Affiliate/affiliate";

const CreateAffiliateInvoiceContainer = (props) => {
  const {
    getAffiliateInvoiceDetail,
    createAffiliateInvoice,
    updateAffiliateInvoice,
    fetchAffiliateDD,
    fetchAffiliateInvoicePayments,
    recordAffiliatePayment,
    isDetailLoading,
    isDetailSuccess,
    isDetailError,
    isCreateSuccess,
    isCreateError,
    isEditSuccess,
    isEditError,
    isRecordPaymentSuccess,
    isRecordPaymentError,
    isUpdatePaymentSuccess,
    isUpdatePaymentError,
    isView,
    isEdit,
    formFieldValueMap: formValues,
    affiliateDD,
    invoicePayments,
    isLoading,
  } = props;

  const { invoiceId } = useParams();

  useEffect(() => {
    fetchAffiliateDD();
    if ((isView || isEdit) && invoiceId) {
      getAffiliateInvoiceDetail(invoiceId);
      if (isView) {
        fetchAffiliateInvoicePayments({ invoiceId });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isView, isEdit, invoiceId]);

  useEffect(() => {
    if (isEditSuccess && invoiceId) {
      getAffiliateInvoiceDetail(invoiceId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditSuccess]);

  const renderProgressBar = () => (
    <ProgressBar mode="indeterminate" style={{ height: "6px" }} />
  );

  const handleEditInvoice = ({ id, data }) => {
    updateAffiliateInvoice(id, data.invoiceStatus, null, {
      status: data.invoiceStatus,
      dueDate: data.dueDate,
      totalCommissionAmount: data.totalCommissionAmount,
    });
  };

  const createAffiliateInvoiceProps = {
    createAffiliateInvoice,
    editAffiliateInvoice: handleEditInvoice,
    isLoading,
    isCreateSuccess,
    isCreateError,
    isEditSuccess,
    isEditError,
    isDetailSuccess,
    isDetailError,
    isEdit: !!isEdit,
    isView: !!isView,
    formFieldValueMap: formValues,
    affiliateDD,
    invoiceId: invoiceId ? Number(invoiceId) : undefined,
    invoicePayments,
    fetchAffiliateInvoicePayments,
    recordAffiliatePayment,
    updateAffiliatePayment: (payload) => props.updateAffiliatePayment(payload, invoiceId),
    isRecordPaymentSuccess,
    isRecordPaymentError,
    isUpdatePaymentSuccess,
    isUpdatePaymentError,
  };

  return (
    <>
      {(isDetailLoading || isLoading) && renderProgressBar()}
      <CreateAffiliateInvoiceComponent {...createAffiliateInvoiceProps} />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    formFieldValueMap: state.affiliateInvoiceReducer?.formFieldValueMap,
    isDetailLoading: state.affiliateInvoiceReducer?.isDetailLoading,
    isDetailSuccess: state.affiliateInvoiceReducer?.isDetailSuccess,
    isDetailError: state.affiliateInvoiceReducer?.isDetailError,
    isLoading: state.affiliateInvoiceReducer?.isLoading,
    isCreateSuccess: state.affiliateInvoiceReducer?.isGenerateInvoiceSuccess,
    isCreateError: state.affiliateInvoiceReducer?.isGenerateInvoiceError,
    isEditSuccess: state.affiliateInvoiceReducer?.isUpdateInvoiceSuccess,
    isEditError: state.affiliateInvoiceReducer?.isUpdateInvoiceError,
    isRecordPaymentSuccess:
      state.affiliateInvoiceReducer?.isRecordPaymentSuccess,
    isRecordPaymentError: state.affiliateInvoiceReducer?.isRecordPaymentError,
    isUpdatePaymentSuccess: state.affiliateInvoiceReducer?.isUpdatePaymentSuccess,
    isUpdatePaymentError: state.affiliateInvoiceReducer?.isUpdatePaymentError,
    affiliateDD: state.affiliateReducer?.affiliateDD || [],
    invoicePayments: state.affiliateInvoiceReducer?.invoicePayments || {},
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAffiliateInvoiceDetail: (invoiceId) =>
      dispatch(getAffiliateInvoiceDetail(invoiceId)),
    createAffiliateInvoice: (payload) =>
      dispatch(generateAffiliateInvoice(payload)),
    updateAffiliateInvoice: (invoiceId, status, currentParams, extraData) =>
      dispatch(updateAffiliateInvoice(invoiceId, status, currentParams, extraData)),
    fetchAffiliateDD: () => dispatch(fetchAffiliateDD()),
    fetchAffiliateInvoicePayments: (payload) =>
      dispatch(fetchAffiliateInvoicePayments(payload)),
    recordAffiliatePayment: (payload, invoiceId) =>
      dispatch(recordAffiliatePayment(payload, invoiceId)),
    updateAffiliatePayment: (payload, invoiceId) =>
      dispatch(updateAffiliatePayment(payload, invoiceId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateAffiliateInvoiceContainer);
